var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(_vm._s(_vm.prefix)+_vm._s(_vm.newValueFormatted)+_vm._s(_vm.suffix))])}
var staticRenderFns = []

export { render, staticRenderFns }